import React from 'react';
import { BlockedUserItem } from './BlockedUserItem';

interface BlockedUser {
    id: number;
    name: string;
    blockedDate: string;
}

interface BlockedUsersListProps {
    users: BlockedUser[];
    totalCount: number;
    searchQuery: string;
    onUnblock: (user: BlockedUser) => void;
}

export const BlockedUsersList: React.FC<BlockedUsersListProps> = ({
    users,
    totalCount,
    searchQuery,
    onUnblock
}) => {
    return (
        <div className="blocked-users-list">
            <div className="list-header">
                차단된 사용자 {totalCount}명
            </div>

            {users.length === 0 ? (
                <div className="empty-state">
                    {searchQuery ? '검색 결과가 없습니다.' : '차단된 사용자가 없습니다.'}
                </div>
            ) : (
                users.map(user => (
                    <BlockedUserItem
                        key={user.id}
                        user={user}
                        onUnblock={onUnblock}
                    />
                ))
            )}
        </div>
    );
};
